module.exports = __webpack_public_path__ + "images/icon-3d-cube.30f72b.svg";